import { User } from "../../../domain/user";
import {
  StringFilterParameter,
  MultiStringFilterParameter,
  KanaFilterParameter,
  InitialFilterParameter,
  EntityFilterParameter,
} from "../../system/filters";

export class UserFilterParameter {
  constructor(
    name: string = "",
    kanaName: string = "",
    initial: string = "",
    professionIds: string[] = [],
    departmentUsers: User[] = null,
    projectTeamUsers: User[] = null,
    designatedDoctorUsers: User[] = null,
    belongedAllDepartmentsUsers: User[] = null) {
    this.name = new StringFilterParameter(name);
    this.kanaName = new KanaFilterParameter(kanaName);
    this.initial = new InitialFilterParameter(initial);
    this.professionIds = new MultiStringFilterParameter(professionIds);
    this.departmentUsers = new EntityFilterParameter(departmentUsers);
    this.projectTeamUsers = new EntityFilterParameter(projectTeamUsers);
    this.designatedDoctorUsers = new EntityFilterParameter(designatedDoctorUsers);
    this.belongedAllDepartmentsUsers = new EntityFilterParameter(belongedAllDepartmentsUsers);
  }

  name: StringFilterParameter;
  kanaName: KanaFilterParameter;
  initial: InitialFilterParameter;
  professionIds: MultiStringFilterParameter;
  departmentUsers: EntityFilterParameter;
  projectTeamUsers: EntityFilterParameter;
  designatedDoctorUsers: EntityFilterParameter;
  belongedAllDepartmentsUsers: EntityFilterParameter;

  filter(source: User): boolean {
    // あかさたなのフィルタと名前のフィルタが競合してしまうので、initial.isEmptyで操作に違和感が無いように暫定対策している
    return (!this.initial.isEmpty || this.name.filter(source.name) || this.kanaName.filter(source.kanaName))
      && this.professionIds.filter(source.profession
        ? source.profession.id
        : "")
      && this.departmentUsers.filter(source)
      && this.projectTeamUsers.filter(source)
      && this.designatedDoctorUsers.filter(source)
      && this.belongedAllDepartmentsUsers.filterNotContains(source)
      && this.initial.filter(source.kanaName);
  }

  clone(): UserFilterParameter {
    return new UserFilterParameter(
      this.name.keyword,
      this.kanaName.keyword,
      this.initial.keyword,
      this.professionIds.keywords,
      this.departmentUsers.entities as User[],
      this.projectTeamUsers.entities as User[],
      this.designatedDoctorUsers.entities as User[],
      this.belongedAllDepartmentsUsers.entities as User[]
    );
  }
}
